import api from "@helpers/api";

import { URLS } from "@constants/urls";

import {
  AddNewLoanTypes,
  InstallmentDetailsResponseTypes,
  InstallmentDetailsTypes,
} from "@type/HRM/gpf";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const createNewLoan = (() => {
  return async (
    employeeID: string | undefined,
    data: AddNewLoanTypes,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/${employeeID}/gpf-loans`, data)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const getInstallmentDetails = (() => {
  return async (
    employeeID: string | undefined,
    loanID: string | undefined,
  ): Promise<{ data: InstallmentDetailsResponseTypes }> => {
    return api
      .get(`${apiEndPoint}/${employeeID}/gpf-loans/${loanID}/installments`)
      .then((response) => {
        return {
          data: response.data,
        };
      });
  };
})();

export const addInstallment = (() => {
  return async (
    employeeID: string | undefined,
    loanID: string | undefined,
    data: Partial<InstallmentDetailsTypes>,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(
        `${apiEndPoint}/${employeeID}/gpf-loans/${loanID}/installments`,
        data,
      )
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const completeInstallment = (() => {
  return async (
    employeeID: string | undefined,
    loanID: string | undefined,
    data: boolean,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(`${apiEndPoint}/${employeeID}/gpf-loans/toggle/${loanID}`, {
        isFullyPaid: data,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();
